export function psigPsiaConvert(
  value: number,
  fromU: string,
  toU: string,
  conds: Record<string, number>
): number {
  const P_atm = conds.P_atm_psi;
  if (fromU === 'psig' && toU === 'psia') return value + P_atm;
  if (fromU === 'psia' && toU === 'psig') return value - P_atm;
  throw new Error(`Unsupported: ${fromU} → ${toU}`);
}
